/*jshint esversion: 9 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";

import store from "../../../components/stores/Store";

import {
  deleteRole,
  updateRoleInfo,
  getRolePrivilege,
  updateRolePrivilege,
} from "../../../db/SystemOperationRequestHandler";
import {
  getIfFuncAuthorized,
} from "../../../utils/CheckSomething";
import ITextField from "../../../components/UI/ITextField";
import CheckHandler from "../../../utils/CheckHandler";

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    // marginBottom: theme.spacing(2),
  },
  tableContainer: {
    maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  from1: {
    marginLeft: "0px",
  },
  from2: {
    marginLeft: "25px",
  },
  from3: {
    marginLeft: "50px",
  },
};
// TableOfqxgl
class TableOfqxglInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
      page: 0,
      dense: true,
      rowsPerPage: 10,
      orderBy: "rolename",
      order: "asc",
      updateDialogOpen: false,
      newRoleName: "",
      idToUpd: "",
      authDialogOpen: false,
      authSettings: {},
      idOfAuthSetting: "",
      deleteLineDialogOpen: false,
      toDeleteId: '',
      authTemplate: {},
    };
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);

    this.handleRequestSort = this.handleRequestSort.bind(this);

    this.createSortHandler = this.createSortHandler.bind(this);

    this.deleteLine = this.deleteLine.bind(this);
    this.updateRoleInfo = this.updateRoleInfo.bind(this);

    this.updateAuthSetting = this.updateAuthSetting.bind(this);
    this.openSettingAuth = this.openSettingAuth.bind(this);
    // this.onAuthDialogChange = this.onAuthDialogChange.bind(this);

    this.onAuthSettingChange = this.onAuthSettingChange.bind(this);
    this.getPrivilegeState = this.getPrivilegeState.bind(this);
    this.closeDeleteLineDialog = this.closeDeleteLineDialog.bind(this);
    this.openDeleteLineDialog = this.openDeleteLineDialog.bind(this);
  }

  async componentDidMount() { }
  componentWillUnmount() { }

  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -1 * this.descendingComparator(a, b, orderBy);
  }

  handleOpen(e, num) {
    this.setState({
      openState: {
        ...this.state.openState,
        [num]: !this.state.openState[num],
      },
    });
  }

  handleRequestSort(event, property) {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc" });
    this.setState({ orderBy: property });
  }

  createSortHandler(event, property) {
    if (property === "action") return;
    this.handleRequestSort(event, property);
  }

  async closeDeleteLineDialog() {
    this.setState({
      toDeleteId: '',
      deleteLineDialogOpen: false,
    });
  }

  openDeleteLineDialog(e, id) {
    this.setState({
      toDeleteId: id,
      deleteLineDialogOpen: true,
    });
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeDeleteLineDialog();
    console.log(`----- send req of deleteRole`);
    const rst = await deleteRole({ ID: id });
    console.log(`----- rst of deleteRole: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "删除成功");
      this.setState({ addDialogOpen: false });
      store.search();
      return true;
    }
  }

  async updateRoleInfo() {
    const roleName = this.state.newRoleName.trim();
    const roleId = this.state.idToUpd.trim();

    const chkRst = CheckHandler.checkParams([
      { key: "角色ID", value: roleId, notNull: true, type: "", maxLength: 64 },
      {
        key: "角色名称",
        value: roleName,
        notNull: true,
        type: "",
        maxLength: 10,
      },
    ]);

    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await updateRoleInfo({ ID: roleId, roleName });
    console.log(`----- rst of updateRoleInfo: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "更新成功");
      this.setState({
        updateDialogOpen: false,
        newRoleName: "",
        idToUpd: "",
      });
      store.search();
      return true;
    }
  }

  async openSettingAuth(id) {
    this.setState({ idOfAuthSetting: id });
    const rst = await getRolePrivilege({ ID: id });
    const authSettings = rst.data;
    const authTemplate = rst.authTemplate;
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "查询错误");
      return true;
    } else if (rst.code === "success") {
    }
    this.setState({
      authSettings: authSettings,
      authDialogOpen: true,
      authTemplate,
    });
  }

  async updateAuthSetting() {
    const ID = this.state.idOfAuthSetting.trim();
    const authTableString = JSON.stringify(this.state.authSettings);

    const chkRst = CheckHandler.checkParams([
      { key: "角色ID", value: ID, notNull: true, type: "", maxLength: 64 },
      {
        key: "权限",
        value: authTableString,
        notNull: true,
        type: "",
        maxLength: 99999,
      },
    ]);

    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await updateRolePrivilege({ ID, authTableString });
    console.log(`----- rst of updateRolePrivilege: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "更新成功");
      this.setState({
        authDialogOpen: false,
        authSettings: {},
      });
      return true;
    }
  }

  onAuthSettingChange(e, ipath) {
    e.stopPropagation();
    console.log(`---- e.target.checked:`, e.target.checked);
    console.log(`---- ipath:`, ipath);
    const ipaths = ipath.split("-");
    console.log(`---- ipaths ${ipaths.length}:`, ipaths);
    const newAuthSettings = this.state.authSettings;
    const name1 = ipaths[0];
    const name2 = ipaths[1] || '';
    const name3 = ipaths[2] || '';
    /**
     * e.g.
      "name1": ["", {
          "name2": ["", {
              "name3": [""],
              "name3": [""],
              "name3": [""],
              "name3": [""],
          }],
     */
    if (name1 && newAuthSettings[name1] === undefined) {
      newAuthSettings[name1] = ["", {}];
    }
    if (name2 && newAuthSettings[name1][1][name2] === undefined) {
      newAuthSettings[name1][1][name2] = ["", {}];
    }
    if (name3 && newAuthSettings[name1][1][name2][1][name3] === undefined) {
      newAuthSettings[name1][1][name2][1][name3] = ["", {}];
    }
    if (ipaths.length === 1) {
      newAuthSettings[name1][0] = e.target.checked;
      this.setState({ authSettings: newAuthSettings });
    }
    if (ipaths.length === 2) {
      console.log(
        `----- newAuthSettings[paths[0]][1][paths[1]][0]: `,
        newAuthSettings[name1][1][name2][0]
      );
      newAuthSettings[name1][1][name2][0] = e.target.checked;
      this.setState({ authSettings: newAuthSettings });
    }
    if (ipaths.length === 3) {
      console.log(
        `----- newAuthSettings[paths[0]][1][paths[1]][1][paths[2]][0]: `,
        newAuthSettings[name1][1][name2][1][name3][0]
      );
      newAuthSettings[name1][1][name2][1][name3][0] =
        e.target.checked;
      this.setState({ authSettings: newAuthSettings });
    }
  }

  getPrivilegeState(ipath) {
    // console.log(`----- getPrivilegeState-ipath: `, ipath);
    const ipaths = ipath.split("-");
    const name1 = ipaths[0];
    const name2 = ipaths[1] || '';
    const name3 = ipaths[2] || '';
    if (ipaths.length === 1) {
      if (!this.state.authSettings[name1]) return false;
      return this.state.authSettings[name1][0];
    } else if (ipaths.length === 2) {
      if (
        !this.state.authSettings[name1] ||
        !this.state.authSettings[name1][1] ||
        !this.state.authSettings[name1][1][name2]
      )
        return false;
      return this.state.authSettings[name1][1][name2][0];
    } else if (ipaths.length === 3) {
      if (
        !this.state.authSettings[name1] ||
        !this.state.authSettings[name1][1] ||
        !this.state.authSettings[name1][1][name2] ||
        !this.state.authSettings[name1][1][name2][1] ||
        !this.state.authSettings[name1][1][name2][1][name3]
      )
        return false;
      return this.state.authSettings[name1][1][name2][1][name3][0];
    }
  }

  render() {
    const { classes } = this.props;
    const headCells = [
      {
        id: "rolename",
        align: "left",
        label: "角色名称",
      },
      { id: "action", align: "center", label: "操作" },
    ];
    try {
      this.authDialog = (
        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.authDialogOpen}
          fullWidth="true"
          maxWidth="xl"
          onClose={(e) => this.setState({ authDialogOpen: false })}
        >
          <DialogTitle id="form-dialog-title">设置权限</DialogTitle>
          <DialogContent>
            {
              Object.keys(this.state.authTemplate).map(
                (itemNameLv1) => {
                  console.log(`----- itemNameLv1: `, itemNameLv1);
                  return (
                    <>
                      <FormGroup row className={classes.from1}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.getPrivilegeState(itemNameLv1)}
                              onChange={(e) =>
                                this.onAuthSettingChange(e, itemNameLv1)
                              }
                              name={itemNameLv1}
                              size="small"
                              color="Secondary"
                            />
                          }
                          label={itemNameLv1}
                        />
                      </FormGroup>
                      {
                        this.state.authTemplate[itemNameLv1][1] && Object.keys(this.state.authTemplate[itemNameLv1][1]).map(
                          (itemNameLv2) => {
                            console.log(`----- itemNameLv2: `, itemNameLv2);
                            return (
                              <>
                                <FormGroup row className={classes.from2}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={this.getPrivilegeState(`${itemNameLv1}-${itemNameLv2}`)}
                                        onChange={(e) =>
                                          this.onAuthSettingChange(e, `${itemNameLv1}-${itemNameLv2}`)
                                        }
                                        name={`${itemNameLv1}-${itemNameLv2}}`}
                                        size="small"
                                        color="primary"
                                      />
                                    }
                                    label={itemNameLv2}
                                  />
                                </FormGroup>
                                {this.state.authTemplate[itemNameLv1][1]
                                  && this.state.authTemplate[itemNameLv1][1][itemNameLv2]
                                  && this.state.authTemplate[itemNameLv1][1][itemNameLv2][1]
                                  &&
                                  (
                                    <FormGroup row className={classes.from3}>
                                      {
                                        this.state.authTemplate[itemNameLv1][1]
                                        && this.state.authTemplate[itemNameLv1][1][itemNameLv2]
                                        && this.state.authTemplate[itemNameLv1][1][itemNameLv2][1]
                                        && Object.keys(this.state.authTemplate[itemNameLv1][1][itemNameLv2][1]).map(
                                          itemNameLv3 => {
                                            console.log(`----- itemNameLv3: `, itemNameLv3);
                                            return (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    checked={this.getPrivilegeState(`${itemNameLv1}-${itemNameLv2}-${itemNameLv3}`)}
                                                    onChange={(e) =>
                                                      this.onAuthSettingChange(e, `${itemNameLv1}-${itemNameLv2}-${itemNameLv3}`)
                                                    }
                                                    name={`${itemNameLv1}-${itemNameLv2}-${itemNameLv3}`}
                                                    size="small"
                                                    color="default"
                                                  />
                                                }
                                                label={itemNameLv3}
                                              />
                                            );
                                          }
                                        )
                                      }
                                    </FormGroup>
                                  )
                                }

                              </>
                            );
                          }
                        )
                      }
                    </>);
                }
              )
            }

          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.updateAuthSetting}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              更新权限
            </Button>
            <Button
              onClick={(e) => this.setState({ authDialogOpen: false })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>
      );
    } catch (error) {
      console.log(`----- authDialog-error: `, error);
    }

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id="TableOfAuthorization"
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      sortDirection={
                        this.state.orderBy === headCell.id
                          ? this.state.order
                          : false
                      }
                    >
                      {headCell.id !== "action" && (
                        <TableSortLabel
                          active={this.state.orderBy === headCell.id}
                          direction={
                            this.state.orderBy === headCell.id
                              ? this.state.order
                              : "asc"
                          }
                          onClick={(event) =>
                            this.createSortHandler(event, headCell.id)
                          }
                        >
                          {headCell.label}
                          {this.state.orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                              {this.state.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      )}

                      {headCell.id === "action" && (
                        <TableSortLabel hideSortIcon key={headCell.id}>
                          {headCell.label}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.stableSort(
                  store.roleTable,
                  this.getComparator(this.state.order, this.state.orderBy)
                )
                  .slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                  )
                  .map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={labelId}
                      >
                        <TableCell
                          component="th"
                          align="left"
                          id={labelId}
                          scope="row"
                        >
                          {row.rolename}
                        </TableCell>
                        <TableCell align="center" style={{ width: "500px" }}>
                          <ButtonGroup
                            variant="contained"
                            aria-label="contained primary button group"
                          >
                            {getIfFuncAuthorized("系统管理-权限管理-修改") && (
                              <Button
                                color="primary"
                                onClick={(e) =>
                                  this.setState({
                                    idToUpd: row.ID,
                                    newRoleName: row.rolename,
                                    updateDialogOpen: true,
                                  })
                                }
                                style={{ width: "150px" }}
                              >
                                修改
                              </Button>
                            )}
                            {getIfFuncAuthorized("系统管理-权限管理-删除") && (
                              <Button
                                color="secondary"
                                onClick={(e) => this.openDeleteLineDialog(e, row.ID)}
                                style={{ width: "150px" }}
                              >
                                删除
                              </Button>
                            )}
                            {/* <Button color="primary">查看用户</Button> */}

                            {getIfFuncAuthorized("系统管理-权限管理-设置权限")
                              && (
                                <Button
                                  color="primary"
                                  onClick={(e) => this.openSettingAuth(row.ID)}
                                  style={{ width: "200px" }}
                                >
                                  设置权限
                                </Button>
                              )}
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.updateDialogOpen}
          onClose={(e) => this.setState({ updateDialogOpen: false })}
        >
          <DialogTitle id="form-dialog-title" style={{ width: "300px" }}>
            添加角色
          </DialogTitle>
          <DialogContent>
            <ITextField
              autoFocus
              margin="dense"
              id="name"
              label="角色名称"
              fullWidth={true}
              ivalue={this.state.newRoleName}
              onChange={(e) => this.setState({ newRoleName: e.target.value })}
              type="email"
              maxLength="10"
              notNull
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.updateRoleInfo}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认更新
            </Button>
            <Button
              onClick={(e) => this.setState({ updateDialogOpen: false })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.deleteLineDialogOpen}
          onClose={this.closeDeleteLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ width: '400px' }}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteLine} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeDeleteLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>

        {this.authDialog}
      </div>
    );
  }
}

const TableOfqxgl = observer(TableOfqxglInner);

TableOfqxgl.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfqxgl);
